import { Controller } from "@hotwired/stimulus"
import Toast from '/libs/toast'

export default class extends Controller {
  connect() {
    this.handleShortcut = this.handleShortcut.bind(this)
    window.addEventListener('keydown', this.handleShortcut)
  }

  disconnect() {
    window.removeEventListener('keydown', this.handleShortcut)
  }

  handleShortcut(event) {
    if (event.altKey && event.metaKey && event.code === 'KeyC') {
      event.preventDefault()
      this.copy()
    }
  }

  copy() {

    const copiedText = document.querySelector('#blog_post_header')
                       ? this.#copyBlogPost()
                       : this.#copyBlogCategory()

    navigator.clipboard.writeText(copiedText).then(() => {
      new Toast("Content copied to clipboard!", 'alert').show()
    }).catch(error => {
      new Toast("Error copying content - See console", 'error').show()
      console.error("Error copying content:", error)
    })
  }



  #copyBlogPost() {
    const title = document.querySelector('#title-field')?.value || ''
    const header = document.querySelector('#blog_post_header')?.value || ''
    const content = document.querySelector('#blog_post_content')?.value || ''
    const metaTitle = document.querySelector('#blog_post_meta_title')?.value || ''
    const metaDescription = document.querySelector('#blog_post_meta_description')?.value || ''

    return `
Meta-Title (60 caractère max):
${metaTitle}

Meta-description (160 caractères max):
${metaDescription}

Title (H1):
${title}

Post Header (Intro dans header):
${header}

Post Content (Body):
${content}
`
  }

  #copyBlogCategory() {
      const title = document.querySelector('#title-field')?.value || ''
      const header = document.querySelector('#blog_category_header')?.value || ''
      const content = document.querySelector('#blog_category_content')?.value || ''
      const metaTitle = document.querySelector('#blog_category_meta_title')?.value || ''
      const metaDescription = document.querySelector('#blog_category_meta_description')?.value || ''

      return `
Meta-Title (60 caractères max) :
${metaTitle}

Meta-description (160 caractères max) :
${metaDescription}

Title (Nom de la catégorie) :
${title}

Post Header (Intro dans header):
${header}

Post Content (Body):
${content}
`
  }
}
